<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { useStayTrail } from '@/breadcrumbs/useStayTrail'

const props = defineProps<{
  administrativeLocalStayId: string
}>()

const { t } = useI18n()
const { stayLinkQuery } = useStayTrail()

const previousStayLink = computed(() => ({
  name: 'mco-stay',
  params: { idType: 'administrativelocalstayid', stayId: props.administrativeLocalStayId },
  query: stayLinkQuery({ targetStayLabel: props.administrativeLocalStayId }),
}))
</script>

<template>
  <div class="reconducted-banner mb-3">
    {{ t('stayDisplayer.mco.automationRules.reconductedFrom') }}
    <router-link :to="previousStayLink">
      {{ administrativeLocalStayId }}
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
.reconducted-banner {
  font-style: italic;
}
</style>
